/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { TokenService } from './customer-api/token.service';

export interface UserInfo {
  email?: string;
  roles?: string[];
  groups?: string[];
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  private cached: UserInfo | null = null;
  private cachedFromToken: string | null = null;

  constructor(private tokenService: TokenService) {}

  get user(): UserInfo | null {
    const token = this.tokenService.getActiveToken();
    if (!token) {
      this.cached = null;
      this.cachedFromToken = null;
      return null;
    }
    if (this.cached && this.cachedFromToken === token) {
      return this.cached;
    }
    try {
      this.cached = jwt_decode(token) as UserInfo;
      this.cachedFromToken = token;
      return this.cached;
    } catch {
      this.cached = null;
      this.cachedFromToken = null;
      return null;
    }
  }

  get email(): string | undefined {
    return this.user?.email;
  }

  get roles(): string[] {
    return this.user?.roles ?? [];
  }

  get groups(): string[] {
    return this.user?.groups ?? [];
  }

  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }

  /** True when the role is granted via either a role or a group on the token. */
  hasRoleOrGroup(role: string): boolean {
    return this.roles.includes(role) || this.groups.includes(role);
  }

  /** ADMIN granted via either a role or a group on the token. */
  get isAdmin(): boolean {
    return this.hasRoleOrGroup('ADMIN');
  }

  clear(): void {
    this.cached = null;
    this.cachedFromToken = null;
  }
}
